import { render, staticRenderFns } from "./WarehouseForm.vue?vue&type=template&id=20c3e190&scoped=true&"
import script from "./WarehouseForm.vue?vue&type=script&lang=js&"
export * from "./WarehouseForm.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseForm.vue?vue&type=style&index=0&id=20c3e190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3e190",
  null
  
)

export default component.exports